/* eslint-disable no-console */
import Breakpoint from './breakpoint';
import Glide from '../vendors/glide.min';
import responseiveItem from './responsive';

const recentlyViewedProductsSlider = () => {
  const slider = document.querySelector('.recently-viewed-products-slider');
  if (!slider) {
    return;
  }
  const navArrows = slider.querySelector('.glide__arrows');
  const slideWrapper = slider.querySelector('.glide__slides');
  // Get number of slides
  const totalSlideCt = slider.querySelectorAll('.glide__slide').length;
  // Map min number of slides needed to scroll at breakpoints
  const map = {};
  map[Breakpoint.XS.name] = 3;
  map[Breakpoint.SM.name] = 3;
  map[Breakpoint.MD.name] = 4;
  map[Breakpoint.LG.name] = 5;
  map[Breakpoint.XL.name] = 6;
  map[Breakpoint.XXL.name] = 6;

  let current = null;
  let glide = null;
  let enabled = false;

  const getGlideBreakpoints = () => {
    const entries = Object.entries(Breakpoint);
    const o = {};
    entries.forEach((breakpoint) => {
      o[breakpoint[1].minWidth] = {
        perView: map[breakpoint[1].name] - 1,
        focusAt: 0,
      };
    });
    return o;
  };

  const toggleSliderUi = (display) => {
    if (display === 'show') {
      slideWrapper.classList.add('justify-content-start');
      slideWrapper.classList.remove('justify-content-center');
      navArrows.classList.remove('hidden');
    } else {
      slideWrapper.classList.add('justify-content-center');
      slideWrapper.classList.remove('justify-content-start');
      navArrows.classList.add('hidden');
    }
  };

  const init = () => {
    toggleSliderUi('show');
    glide = new Glide(slider, {
      type: 'carousel',
      startAt: 0,
      gap: 0,
      autoplay: 0,
      hoverpause: true,
      perView: map[Breakpoint.XXL.name] - 1,
      breakpoints: getGlideBreakpoints(),
    });
    glide.mount();
  };

  const destroy = () => {
    toggleSliderUi('hide');
    if (glide) {
      glide.destroy();
    }
  };

  const onNewBreakpoint = (breakpoint) => {
    if (breakpoint === current) {
      return;
    }
    current = breakpoint;
    const minSlideCt = map[breakpoint.name];
    if (totalSlideCt < minSlideCt && enabled) {
      enabled = false;
      destroy();
    }
    if (totalSlideCt >= minSlideCt && !enabled) {
      enabled = true;
      init();
    }
  };
  responseiveItem(onNewBreakpoint);
};

export default recentlyViewedProductsSlider;
/* eslint-enable no-console */
